import _ from "lodash";

import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	data: () => ({
		stepNumber: null,
	}),

	computed: {
		...mapState("wizard", ["busy", "done", "index"]),

		...mapGetters({
			cls: "wizard/cls",
			device: "wizard/device",
		}),
	},

	watch: {
		async index(val) {
			if (_.isNil(this.stepNumber)) {
				this.$log(`Wizard: Step changed ${this.index}`);
				return;
			}

			this.$log(
				`Wizard: Step changed ${this.index} from current step number ${this.stepNumber}`
			);

			if (val === this.stepNumber) {
				this.start();
			} else {
				// Cancel pairing
				if (this.busy) this.stop();
			}
		},
	},

	methods: {
		...mapMutations({
			setDisableNext: "wizard/setDisableNext",
			setDisableBack: "wizard/setDisableBack",
			setBusy: "wizard/setBusy",
		}),

		start() {
			// Default start implementation
		},

		stop() {
			// Default stop implementation
		},

		async showError(error, retry) {
			console.error(error);

			this.$log(`Wizard: Error ${error}`);

			this.setBusy(false);

			const button = retry ? "Retry" : null;
			let yes = await this.$store.dispatch("wizard/showPopup", {
				title: "There's a problem...",
				text: error,
				button,
			});

			if (yes) this.start();
		},
	},
};
